const MAX_GOAL_LEN = 80;
const CONTROL_CHARS_RE = /[\x00-\x1F\x7F]/g;

function sanitizeGoal(goal: string | null | undefined): string | null {
  if (!goal) return null;
  const cleaned = goal.replace(CONTROL_CHARS_RE, "").trim().slice(0, MAX_GOAL_LEN);
  return cleaned.length > 0 ? cleaned : null;
}

export function getGoalPromptSeed(goal: string | null | undefined): string | null {
  const safe = sanitizeGoal(goal);
  if (!safe) return null;
  return `You set Speak up for ${safe}. This file is a great place to begin.`;
}

export function getActivationChatHint(goal: string | null | undefined): string | null {
  const safe = sanitizeGoal(goal);
  if (!safe) return null;
  return `Ask Speak about your ${safe} files`;
}
